import { Notifier } from '@airbrake/browser'

var airbrake = new Notifier({
    environment: process.env.VUE_APP_AIRBRAKE_ENVIRONMENT,
    projectId: process.env.VUE_APP_AIRBRAKE_PROJECT_ID,
    projectKey: process.env.VUE_APP_AIRBRAKE_PROJECT_KEY,
})

export default airbrake
